
import type { SVGProps } from 'react';
const SvgPercent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      d="M7.25 10.5q-1.35 0-2.3-.95A3.13 3.13 0 0 1 4 7.25q0-1.35.95-2.3T7.25 4t2.3.95.95 2.3-.95 2.3-2.3.95m0-1.5q.725 0 1.238-.512Q9 7.975 9 7.25t-.512-1.237A1.69 1.69 0 0 0 7.25 5.5q-.725 0-1.237.513A1.69 1.69 0 0 0 5.5 7.25q0 .725.513 1.238Q6.525 9 7.25 9m9.5 11q-1.35 0-2.3-.95a3.13 3.13 0 0 1-.95-2.3q0-1.35.95-2.3t2.3-.95 2.3.95.95 2.3-.95 2.3-2.3.95m0-1.5q.725 0 1.238-.512.512-.513.512-1.238t-.512-1.238A1.69 1.69 0 0 0 16.75 15q-.725 0-1.238.512A1.69 1.69 0 0 0 15 16.75q0 .725.512 1.238.513.512 1.238.512M5.05 20 4 18.95 18.95 4 20 5.05z"
    />
    <path
      fill="#263E6A"
      d="M7.5 10.5q-1.257 0-2.129-.871-.87-.87-.871-2.129 0-1.257.871-2.129.87-.87 2.129-.871 1.257 0 2.129.871.87.87.871 2.129 0 1.257-.871 2.129-.87.87-2.129.871m0-1q.817 0 1.409-.591Q9.5 8.317 9.5 7.5t-.591-1.409A1.92 1.92 0 0 0 7.5 5.5q-.817 0-1.409.591A1.92 1.92 0 0 0 5.5 7.5q0 .817.591 1.409.592.591 1.409.591m9 10q-1.257 0-2.129-.871-.87-.87-.871-2.129 0-1.257.871-2.129.87-.87 2.129-.871 1.257 0 2.129.871.87.87.871 2.129 0 1.257-.871 2.129-.87.87-2.129.871m0-1q.817 0 1.409-.591.591-.592.591-1.409t-.591-1.409A1.92 1.92 0 0 0 16.5 14.5q-.817 0-1.409.591A1.92 1.92 0 0 0 14.5 16.5q0 .817.591 1.409.592.591 1.409.591m-11.1.788-.688-.688L18.6 4.712l.688.688z"
    />
  </svg>
);
export default SvgPercent;
